import { Card, CardContent } from "@/components/ui/card";

export const ProcessSection = () => {
  const steps = [
    {
      number: "01",
      title: "Data Source Analysis",
      description: "We analyze your existing data sources and requirements to create an integration strategy."
    },
    {
      number: "02",
      title: "Connection Setup",
      description: "Set up secure connections between your various data sources and destinations."
    },
    {
      number: "03",
      title: "Data Mapping",
      description: "Create detailed mappings between source and destination data structures."
    },
    {
      number: "04",
      title: "Testing & Validation",
      description: "Thoroughly test the integration and validate data accuracy and completeness."
    }
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">
          Our Integration Process
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-shadow">
              <CardContent className="p-6">
                <div className="text-4xl font-bold text-blue-600 mb-4">{step.number}</div>
                <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};